module.exports = __webpack_public_path__ + "img/stepsTwo.9d2902bc.svg";